module.exports = __webpack_public_path__ + "static/img/produto_p.25466a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/guarana-zero/produto_p.png
// module id = la2r
// module chunks = 0